<template>
  <div>
    <q-form ref="editForm" class="q-mb-sm">
      <c-card class="cardClassDetailForm" title="LBLDETAIL">
        <template slot="card-button">
          <q-btn-group outline >
              <c-btn 
                v-if="editable && !disabled" 
                :isSubmit="isSave"
                :url="saveUrl"
                :param="year"
                :mappingType="mappingType"
                label="LBLSAVE" 
                icon="save"
                @beforeAction="saveYear"
                @btnCallback="saveYearCallback" />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <c-text
              :required="true"
              :disabled="disabled"
              :editable="editable"
              label="실시계획서명"
              name="planName"
              v-model="year.planName">
            </c-text>
          </div>
          <div class="col-xs-6 col-sm-2 col-md-2 col-lg-2">
            <!-- 년도 -->
            <c-datepicker
              :required="true"
              :disabled="disabled"
              :editable="editable"
              type="year"
              label="LBLYEAR"
              name="planYear"
              v-model="year.planYear"
            />
          </div>
          <div class="col-xs-6 col-sm-2 col-md-2 col-lg-2">
            <!-- 주관부서 -->
            <c-dept
              :required="true"
              :disabled="disabled"
              :editable="editable"
              label="주관부서"
              name="deptCd"
              v-model="year.deptCd">
            </c-dept>
          </div>
          <div class="col-xs-6 col-sm-2 col-md-2 col-lg-2">
            <c-plant
              :required="true"
              :disabled="disabled"
              :editable="editable"
              name="plantCd"
              v-model="year.plantCd">
            </c-plant>
          </div>
          <div class="col-12">
            <c-textarea
              :editable="editable"
              :disabled="disabled"
              :rows="8"
              label="심사범위"
              name="auditScope"
              v-model="year.auditScope">
            </c-textarea>
          </div>
        </template>
      </c-card>
    </q-form>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
        <c-table
          ref="plantable"
          title="실시계획 목록"
          :columns="gridColumns"
          :data="grid.data"
          :gridHeight="gridHeight"
          :editable="editable&&!disabled"
          :hideBottom="true"
          :isExcelDown="false"
          :filtering="false"
          :isFullScreen="false"
          :columnSetting="false"
          selection="multiple"
          rowKey="deptCd"
          checkDisableColumn="deptFlag"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn 
                v-if="editable&&!disabled" 
                label="LBLEXCEPT" icon="remove" 
                @btnClicked="deleteTarget" />
              <c-btn 
                v-if="editable&&!disabled" 
                label="LBLADD" icon="add" 
                @btnClicked="addTarget" />
            </q-btn-group>
          </template>
          <template v-slot:customArea="{ props, col }">
            <q-checkbox
              v-if="props.rowIndex !== (grid.data.length - 1)"
              v-model="props.row[col.name]"
              :editable="editable&&!disabled"
              color="orange-custom" 
              true-value="Y"
              false-value="N"
              dense
              @input="datachange(props, col, 'c')"
            />
            <c-textarea-column
              v-else
              :editable="editable&&!disabled"
              :col="col"
              :props="props"
              class="text-left"
              @datachange="datachange(props, col, 't')"
            />
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
        <c-table
          ref="teamtable"
          title="심사팀 목록"
          :columns="gridTeam.columns"
          :data="year.auditTeams"
          :gridHeight="gridHeight"
          :editable="editable&&!disabled"
          :hideBottom="true"
          :isExcelDown="false"
          :filtering="false"
          :isFullScreen="false"
          :columnSetting="false"
          selection="multiple"
          rowKey="userId"
        >
          <!-- @linkClick="linkClick" -->
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn 
                v-if="editable&&!disabled" 
                label="LBLEXCEPT" icon="remove" 
                @btnClicked="deleteTeam" />
              <c-btn 
                v-if="editable&&!disabled" 
                label="LBLADD" icon="add" 
                @btnClicked="addTeam" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
// import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'internal-year-plan-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        saiInternalYearPlanId: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      year: {
        saiInternalYearPlanId: '',  // 연간 내부감사 일련번호
        plantCd: '',  // 사업장코드
        planYear: '',  // 심사년
        planName: '',  // 실시계획서명
        auditScope: '',  // 심사범위
        deptCd: '',  // 주관부서코드
        saiInternalYearPlanStepCd: '',  // 연간 내부심사 진행상태
        regUserId: '',  // 등록자 ID
        chgUserId: '',  // 수정자 ID
        approvalStatusCd: '', // 결재관련 결재상태
        sysApprovalRequestId: '', // 결재관련 결재요청코드
        auditMonth: [], // 심사월
        targetDepts: [], // 피심사팀
        deleteTargetDepts: [], // 피심사팀
        auditTeams: [], // 심사팀
        deleteAuditTeams: [], // 심사팀 [삭제]
      },
      grid: {
        defaultColumns: [
          {
            name: 'deptName',
            field: 'deptName',
            label: '피심사팀',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
        ],
        data: [],
      },
      gridTeam: {
        columns: [],
      },
      editable: true,
      mappingType: 'PUT',
      detailUrl: '',
      saveUrl: '',
      deleteUrl: '',
      approvalUrl: '',
      isSave: false,
      isApproval: false,
      popupOptions: {
        isFull: false,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    disabled() {
      return this.year.saiInternalYearPlanStepCd === 'IYP0000005'
    },
    isOld() {
      return Boolean(this.popupParam.saiInternalYearPlanId);
    },
    gridHeight() {
      return String(this.contentHeight - 400) + 'px';
    },
    gridColumns() {
      let columns = this.$_.cloneDeep(this.grid.defaultColumns);
      for(let i = 1; i <= 12; i++) {
        columns.push({
          name: `mon${i}`,
          field: `mon${i}`,
          yearmonth: `${this.year.planYear}-${this.$_.padStart(i, 2, '0')}`,
          label: `${i}월`,
          align: 'center',
          style: 'width:70px',
          sortable: true,
          type: 'custom',
        })
      }
      return columns;
    },
  },
  watch: {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.sai.internal.yearPlan.get.url;
      this.saveUrl = transactionConfig.sai.internal.yearPlan.insert.url;
      this.deleteUrl = transactionConfig.sai.internal.yearPlan.delete.url;
      this.approvalUrl = transactionConfig.sai.internal.yearPlan.update.url;
      // code setting
      this.$comm.getComboItems('SAI_INTERNAL_AUDIT_TEAM_ROLE_CD').then(_result => {
        this.gridTeam.columns = [
          {
            name: 'saiInternalAuditTeamRoleCd',
            field: 'saiInternalAuditTeamRoleCd',
            label: 'LBLROLE',
            align: 'center',
            style: 'width:30%',
            type: 'select',
            comboItems: _result,
            sortable: false,
          },
          {
            name: 'userName',
            field: 'userName',
            label: 'LBLNAME',
            align: 'center',
            style: 'width:30%',
            sortable: true,
          },
          {
            name: 'deptName',
            field: 'deptName',
            label: '심사팀',
            align: 'center',
            style: 'width:40%',
            sortable: true,
          },
        ]
      });
      // list setting
      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.saiInternalYearPlanId) {
        this.$http.url = this.$format(this.detailUrl, this.popupParam.saiInternalYearPlanId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.$_.extend(this.year, _result.data);

          if (!this.year.targetDepts) this.year.targetDepts = [];
          let _auditmon = {
            deptFlag: true,
            deptName: 'LBLREMARK',
            mon1: '',
            mon2: '',
            mon3: '',
            mon4: '',
            mon5: '',
            mon6: '',
            mon7: '',
            mon8: '',
            mon9: '',
            mon10: '',
            mon11: '',
            mon12: '',
          }
          this.$_.forEach(this.year.auditMonth, month => {
            let _mon = this.$_.replace(month.yearmonth, `${this.year.planYear}-`, '')
            _mon = !isNaN(_mon) ? Number(_mon) : 0;
            if (_mon) {
              this.$set(_auditmon, `mon${_mon}`, month.remark)
            }
          })
          this.grid.data = [];
          this.grid.data = this.$_.concat(this.year.targetDepts, [_auditmon])
        },);
      } else {
        // 신규등록인 경우
        this.$set(this.year, 'planYear', this.$comm.getThisYear());
        this.$set(this.year, 'saiInternalYearPlanStepCd', 'IYP0000001'); // 직성중
        this.year.auditMonth = [];
        this.$_.forEach(this.gridColumns, col => {
          if (col.name === 'deptName') return;
          this.year.auditMonth.push({
            yearmonth: col.yearmonth,
            remark: '',
            editFlag: 'C',
            regUserId: this.$store.getters.user.userId,
          })
        });
        this.grid.data = [{
          deptFlag: true,
          deptName: 'LBLREMARK',
          mon1: '',
          mon2: '',
          mon3: '',
          mon4: '',
          mon5: '',
          mon6: '',
          mon7: '',
          mon8: '',
          mon9: '',
          mon10: '',
          mon11: '',
          mon12: '',
        }];
      }
    },
    datachange(props, col, type) {
      if (props.row['editFlag'] !== 'C') {
        props.row['editFlag'] = 'U'
        props.row['chgUserId'] = this.$store.getters.user.userId
      }

      if (type === 't') {
        // textarea
        if (this.year.auditMonth && this.year.auditMonth.length > 0) {
          let _f_data = this.$_.find(this.year.auditMonth, month => {
            return month.yearmonth === col.yearmonth
          })
          if (_f_data) {
            this.$set(_f_data, 'remark', props.row[col.name])
            if (_f_data['editFlag'] !== 'C') {
              _f_data['editFlag'] = 'U'
              _f_data['chgUserId'] = this.$store.getters.user.userId
            }
          }
        }

      }
    },
    setSaveValue() {
      return new Promise(resolve => {
        this.year.regUserId = this.$store.getters.user.userId
        this.year.chgUserId = this.$store.getters.user.userId

        // 피심사팀
        if (this.grid.data && this.grid.data.length > 1) {
          let _data = this.grid.data.slice(0, this.grid.data.length - 1)
          this.year.targetDepts = this.$_.cloneDeep(_data);
        }

        resolve(true);
      });
    },
    saveValue() {
      return new Promise(resolve => {
        this.isSave = !this.isSave
        resolve(true);
      });
    },
    saveYear() {
      if (this.popupParam.saiInternalYearPlanId) {
        this.mappingType = 'PUT'
        this.saveUrl = transactionConfig.sai.internal.yearPlan.update.url;
      } else {
        this.mappingType = 'POST'
        this.saveUrl = transactionConfig.sai.internal.yearPlan.insert.url;
      }
      
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGSAVE', // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              let promises = [
                {
                  func: this.setSaveValue,
                },
                {
                  func: this.saveValue
                },
              ];
              this.$comm.orderedPromise(promises);
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveYearCallback(_result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.saiInternalYearPlanId = _result.data
      this.getDetail();
    },
    addTarget() {
      this.popupOptions.title = 'LBL0000518'; // 부서조회
      this.popupOptions.param = {
        plantCd: this.year.plantCd,
      }
      this.popupOptions.target = () => import(`${'@/pages/common/dept/deptMultiPop.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.width = '50%';
      this.popupOptions.closeCallback = this.closeDept;
    },
    closeDept(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.grid.data, { deptCd: item.deptCd }) === -1) {
            this.grid.data.splice(0, 0, {
              saiInternalYearPlanId: this.popupParam.saiInternalYearPlanId,
              deptCd: item.deptCd,
              deptName: item.deptName,
              mon1: 'N',
              mon2: 'N',
              mon3: 'N',
              mon4: 'N',
              mon5: 'N',
              mon6: 'N',
              mon7: 'N',
              mon8: 'N',
              mon9: 'N',
              mon10: 'N',
              mon11: 'N',
              mon12: 'N',
              editFlag: 'C',
              regUserId: this.$store.getters.user.userId,
            })
          }
        });
      }
    },
    deleteTarget() {
      let selectData = this.$refs['plantable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: '제외할 행을 지정하세요.', // 제외할 행을 지정하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGEXCEPT', // 제외하시겠습니까?
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$_.forEach(selectData, item => {
              if (!this.year.deleteTargetDepts) {
                this.year.deleteTargetDepts = [];
              }
              if (this.$_.findIndex(this.year.deleteTargetDepts, { deptCd: item.deptCd }) === -1) {
                this.year.deleteTargetDepts.push(item)
              }
              this.grid.data = this.$_.reject(this.grid.data, item);
              this.$refs['plantable'].$refs['compo-table'].clearSelection();
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    addTeam() {
      this.popupOptions.title = 'LBL0000560'; // 사용자 검색
      this.popupOptions.param = {
        type: 'multiple'
      };
      this.popupOptions.target = () => import(`${'@/pages/common/user/userPop.vue'}`);
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeUserPopup;
    },
    closeUserPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        let _data = [];
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.year.auditTeams, { userId: item.userId }) === -1) {
            _data.push({
              saiInternalYearPlanId: this.popupParam.saiInternalYearPlanId,
              deptCd: item.deptCd, deptName: item.deptName, 
              userId: item.userId, userName: item.userName, 
              saiInternalAuditTeamRoleCd: 'IATR000005',
              editFlag: 'C',
              regUserId: this.$store.getters.user.userId,
            })
          }
        })
        this.year.auditTeams = this.$_.concat(_data, this.year.auditTeams)
      }
    },
    deleteTeam() {
      let selectData = this.$refs['teamtable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: '제외할 행을 지정하세요.', // 제외할 행을 지정하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGEXCEPT', // 제외하시겠습니까?
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$_.forEach(selectData, item => {
              if (!this.year.deleteAuditTeams) {
                this.year.deleteAuditTeams = [];
              }
              if (this.$_.findIndex(this.year.deleteAuditTeams, { userId: item.userId }) === -1) {
                this.year.deleteAuditTeams.push(item)
              }
              this.year.auditTeams = this.$_.reject(this.year.auditTeams, item);
              this.$refs['teamtable'].$refs['compo-table'].clearSelection();
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
  }
};
</script>